/* eslint-disable react-hooks/exhaustive-deps */
import { useRef, useEffect, useState } from "react";

export function usePrevious(value) {
  const ref = useRef();

  useEffect(() => {
    ref.current = value;
  }, [value]); // Only re-run if value changes

  return ref.current;
}

export function usePreviousValues(values) {
  const ref = useRef();

  useEffect(() => {
    ref.current = values;
  }, values); // Only re-run if value changes

  return ref.current;
}

export function useStateWithDeps(defaultValue, dependencies) {
  const [state, setState] = useState(defaultValue);
  const prevDeps = usePreviousValues(dependencies);

  useEffect(() => {
    if (dependencies.length === 2)
      console.log("Changing to default", defaultValue)
    setState(defaultValue)
  }, dependencies)

  if (prevDeps) {
    for (let i = 0; i < dependencies.length; ++i) {
      if (prevDeps[i] !== dependencies[i]) {
        // if (dependencies.length === 1)
        //   console.log("Defaulting: ", defaultValue, "Original value: ", state, "deps: ", dependencies)
        return [defaultValue, setState];
      }
    }
  }

  return [state, setState];
}

export const useMountEffect = (fun) => useEffect(fun, []);
